import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
`;

export const Card = styled.div`
  text-align: center;
  padding: 60px 40px;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 100%;
`;

export const ErrorCode = styled.h1`
  font-size: 72px;
  color: ${p => p.accent};
  margin: 0;
  font-weight: 700;
`;

export const Message = styled.p`
  color: var(--text-color);
  font-size: 24px;
  margin: 20px 0;
`;

export const Description = styled.p`
  color: var(--text-color);
  font-size: 16px;
  margin: 20px 0 30px;
  opacity: 0.75;
`;

export const BackBtn = styled.button`
  padding: 12px 30px;
  background: ${p => p.accent};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px ${p => p.accent}66;
  }
`;
